/**
 * @generated SignedSource<<24190d77238e63ee271636083675a435>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActivateUserInput = {
  clientMutationId?: string | null;
  token: string;
};
export type useAuthContext_ActivateUserMutation$variables = {
  input: ActivateUserInput;
};
export type useAuthContext_ActivateUserMutation$data = {
  readonly Auth: {
    readonly activateUser: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type useAuthContext_ActivateUserMutation = {
  response: useAuthContext_ActivateUserMutation$data;
  variables: useAuthContext_ActivateUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ActivateUserPayload",
        "kind": "LinkedField",
        "name": "activateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthContext_ActivateUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthContext_ActivateUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "de1c07264680f657abfddf7bed90de06",
    "id": null,
    "metadata": {},
    "name": "useAuthContext_ActivateUserMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthContext_ActivateUserMutation(\n  $input: ActivateUserInput!\n) {\n  Auth {\n    activateUser(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "53de6c1c811599e2a448b2edc6258ffd";

export default node;
